module.exports = __webpack_public_path__ + "img/logo.b804d84b.png";